import { useTranslation } from "react-i18next";

interface LegendItem {
  status: string;
  labelKey: string;
  swatchClass: string;
}

const legendItems: LegendItem[] = [
  {
    status: "available",
    labelKey: "seats.legend.available",
    swatchClass: "bg-white border-hairline-strong",
  },
  {
    status: "selected",
    labelKey: "seats.legend.selected",
    swatchClass: "bg-ink border-ink",
  },
  {
    status: "held",
    labelKey: "seats.legend.held",
    swatchClass: "bg-stone-200 border-hairline-strong",
  },
  {
    status: "occupied",
    labelKey: "seats.legend.occupied",
    swatchClass: "bg-stone-100 border-hairline",
  },
];

export function SeatLegend() {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-wrap gap-x-5 gap-y-2 justify-center">
      {legendItems.map((item) => (
        <li key={item.status} className="flex items-center gap-2">
          <span
            className={`h-3.5 w-3.5 border ${item.swatchClass}`}
            aria-hidden="true"
          />
          <span className="text-eyebrow uppercase text-ink-muted">
            {t(item.labelKey)}
          </span>
        </li>
      ))}
    </ul>
  );
}
